import { c as _c } from "react/compiler-runtime";
import CustomButton from './components/custom-button';
import GrantEditRightsDialog from './components/grant-edit-rights-dialog';
import useAssumeBanner from './hooks/use-assume-banner';
type AssumeBannerProps = {
  hideActions?: boolean;
};
const AssumeBanner = t0 => {
  const $ = _c(30);
  const {
    hideActions
  } = t0;
  const {
    t,
    showEditRightsForm,
    canRequestAdditionalPermissions,
    currentPermissions,
    isAssumedSession,
    isAssumedSessionEditMode,
    isAccessRequestsPending,
    org,
    handleChangeEdit,
    handleCloseEditRightsForm,
    handleRequestAdditionalPermissions,
    handleLogout,
    getEditButtonText
  } = useAssumeBanner();
  if (!isAssumedSession) {
    return null;
  }
  const t1 = `w-full sticky top-0 z-50 ${isAssumedSessionEditMode ? "bg-error text-error" : "bg-primary text-primary"} text-body-2 max-w-full rounded-t flex items-center justify-center`;
  let t2;
  if ($[0] !== isAssumedSessionEditMode || $[1] !== org?.name || $[2] !== t) {
    t2 = isAssumedSessionEditMode ? t(_temp, {
      orgName: org?.name
    }) : t(_temp2, {
      orgName: org?.name
    });
    $[0] = isAssumedSessionEditMode;
    $[1] = org?.name;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = hideActions ? "." : "";
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="flex items-center gap-1">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== canRequestAdditionalPermissions || $[8] !== getEditButtonText || $[9] !== handleChangeEdit || $[10] !== handleLogout || $[11] !== handleRequestAdditionalPermissions || $[12] !== hideActions || $[13] !== isAccessRequestsPending || $[14] !== isAssumedSessionEditMode || $[15] !== t) {
    t5 = !hideActions && <><span className="mx-2">·</span>{!isAccessRequestsPending && <><CustomButton onClick={handleChangeEdit} disabled={isAccessRequestsPending} isAssumedSessionEditMode={isAssumedSessionEditMode}>{getEditButtonText()}</CustomButton>{canRequestAdditionalPermissions && <><span className="mx-2">·</span><CustomButton onClick={handleRequestAdditionalPermissions} disabled={isAccessRequestsPending} isAssumedSessionEditMode={isAssumedSessionEditMode}>{t(_temp3)}</CustomButton></>}<span className="mx-2">·</span></>}<CustomButton onClick={handleLogout} disabled={isAccessRequestsPending} isAssumedSessionEditMode={isAssumedSessionEditMode}>{t(_temp4)}</CustomButton></>;
    $[7] = canRequestAdditionalPermissions;
    $[8] = getEditButtonText;
    $[9] = handleChangeEdit;
    $[10] = handleLogout;
    $[11] = handleRequestAdditionalPermissions;
    $[12] = hideActions;
    $[13] = isAccessRequestsPending;
    $[14] = isAssumedSessionEditMode;
    $[15] = t;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <div className="flex items-baseline pt-2 pb-2.5">{t4}{t5}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t1 || $[21] !== t6) {
    t7 = <div className={t1} role="alert">{t6}</div>;
    $[20] = t1;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== currentPermissions || $[24] !== handleCloseEditRightsForm || $[25] !== showEditRightsForm) {
    t8 = <GrantEditRightsDialog open={showEditRightsForm} onClose={handleCloseEditRightsForm} initialScopes={currentPermissions} />;
    $[23] = currentPermissions;
    $[24] = handleCloseEditRightsForm;
    $[25] = showEditRightsForm;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t7 || $[28] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
};
export default AssumeBanner;
function _temp($) {
  return $.editModeTitle;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.requestAdditional;
}
function _temp4($_2) {
  return $_2.logOut;
}